export default function DomText() {
  return (
    <p className="lead mt-2 mb-4">
      В цьому розділі зібрані задачі, що допоможуть Вам опанувати типові методи
      зміни структури, вмісту та стилів WEB-сторінок.
    </p>
  );
}
